var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1127.45 699.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.d,.e{fill:#fff;}.a{stroke:#707070;}.b,.c{opacity:0.28;}.c,.d{stroke:#0265ff;}.c,.d,.f,.g{stroke-width:2px;}.f,.g,.m{fill:none;}.f{stroke:#b0cdfb;}.g,.h{stroke:#0066f9;}.h{fill:#e3eeff;stroke-width:3px;}.i{clip-path:url(#a);}.j{fill:url(#b);}.k,.l{stroke:none;}.l{fill:#0265ff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 726,
    height: 221,
    transform: "translate(618 710)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3eeff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3eeff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-396.326 -316.432)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(13361.563 6113.023) rotate(22)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M -13924.8466796875 -153.0263061523438 C -13926.390625 -153.0263061523438 -13927.8916015625 -154.2438354492188 -13929.0732421875 -156.4546203613281 L -13953.9296875 -202.9992980957031 L -13895.759765625 -202.9992980957031 L -13920.623046875 -156.4542846679688 C -13921.8046875 -154.2438354492188 -13923.3046875 -153.0263061523438 -13924.8466796875 -153.0263061523438 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M -13924.8466796875 -154.0263061523438 C -13923.7080078125 -154.0263061523438 -13922.490234375 -155.0832366943359 -13921.5048828125 -156.9254455566406 L -13897.427734375 -201.9992980957031 L -13952.2626953125 -201.9992980957031 L -13928.19140625 -156.9261169433594 C -13927.2060546875 -155.0832366943359 -13925.9873046875 -154.0263061523438 -13924.8466796875 -154.0263061523438 M -13924.8466796875 -152.0263061523438 C -13926.7744140625 -152.0263061523438 -13928.5908203125 -153.4315185546875 -13929.955078125 -155.9831085205078 L -13955.59765625 -203.9992980957031 L -13894.091796875 -203.9992980957031 L -13919.7412109375 -155.9831085205078 C -13921.10546875 -153.4315185546875 -13922.919921875 -152.0263061523438 -13924.8466796875 -152.0263061523438 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1468.5 613)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 14,
    cy: 14,
    r: 13
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1106.5 508)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 14,
    cy: 14,
    r: 13
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(418.5 828)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 26,
    height: 26,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 826.118, 463.321)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 26,
    height: 26,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 1350.449, 432.466)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 41,
    height: 41,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 39,
    height: 39,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 1076.556, 711.289)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 25,
    height: 25,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1456.5 842)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 24,
    height: 24,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(555.5 522)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 24,
    height: 24,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(6619.916 -11652.883) rotate(-65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M -13934.2998046875 -178.3831329345703 C -13935.3056640625 -178.3831329345703 -13936.2744140625 -178.9557800292969 -13937.0263671875 -179.99560546875 L -13953.640625 -202.9992828369141 L -13914.955078125 -202.9992828369141 L -13931.5732421875 -179.9950561523438 C -13932.3251953125 -178.9557952880859 -13933.2939453125 -178.3831329345703 -13934.2998046875 -178.3831329345703 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M -13934.2998046875 -179.3831329345703 C -13933.38671875 -179.3831329345703 -13932.70703125 -180.1340942382813 -13932.3837890625 -180.5806427001953 L -13916.9111328125 -201.9992828369141 L -13951.685546875 -201.9992828369141 L -13936.216796875 -180.5817413330078 C -13935.892578125 -180.1340942382813 -13935.212890625 -179.3831329345703 -13934.2998046875 -179.3831329345703 M -13934.2998046875 -177.3831329345703 C -13935.634765625 -177.3831329345703 -13936.8916015625 -178.1027679443359 -13937.8369140625 -179.4094696044922 L -13955.5966796875 -203.9992828369141 L -13912.9990234375 -203.9992828369141 L -13930.7626953125 -179.4094696044922 C -13931.7080078125 -178.1027679443359 -13932.96484375 -177.3831329345703 -13934.2998046875 -177.3831329345703 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(-0.017, 1, -1, -0.017, 158.348, 14267.251)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M -13924.8466796875 -153.0263061523438 C -13926.390625 -153.0263061523438 -13927.8916015625 -154.2438354492188 -13929.0732421875 -156.4546203613281 L -13953.9296875 -202.9992980957031 L -13895.759765625 -202.9992980957031 L -13920.623046875 -156.4542846679688 C -13921.8046875 -154.2438354492188 -13923.3046875 -153.0263061523438 -13924.8466796875 -153.0263061523438 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M -13924.8466796875 -154.0263061523438 C -13923.7080078125 -154.0263061523438 -13922.490234375 -155.0832366943359 -13921.5048828125 -156.9254455566406 L -13897.427734375 -201.9992980957031 L -13952.2626953125 -201.9992980957031 L -13928.19140625 -156.9261169433594 C -13927.2060546875 -155.0832366943359 -13925.9873046875 -154.0263061523438 -13924.8466796875 -154.0263061523438 M -13924.8466796875 -152.0263061523438 C -13926.7744140625 -152.0263061523438 -13928.5908203125 -153.4315185546875 -13929.955078125 -155.9831085205078 L -13955.59765625 -203.9992980957031 L -13894.091796875 -203.9992980957031 L -13919.7412109375 -155.9831085205078 C -13921.10546875 -153.4315185546875 -13922.919921875 -152.0263061523438 -13924.8466796875 -152.0263061523438 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1407.5 988)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 14,
    cy: 14,
    r: 13
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 703.682, 392.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 24,
    height: 24,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4
  })), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y1: 32,
    x2: 26,
    transform: "translate(1497 715.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "g",
    y1: 32,
    x2: 26,
    transform: "translate(1261 367.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 34,
    y1: 31,
    transform: "translate(397 656.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 34,
    y1: 31,
    transform: "translate(1350 694.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M229.122-7.45H190.4V42.481H136.733V-7.45H8.68V-44.473L120.769-195.284h57.743l-103.937,143h63.857v-44.5H190.4v44.5h38.722ZM364.309,46.557q-29.551,0-52.648-14.606T275.486-10.337Q262.409-38.019,262.409-76.4t13.077-66.065q13.077-27.683,36.174-42.288t52.648-14.606q29.551,0,52.648,14.606t36.174,42.288q13.077,27.683,13.077,66.065T453.131-10.337q-13.077,27.683-36.174,42.288T364.309,46.557Zm0-46.534q21.739,0,34.136-18.682t12.4-57.743q0-39.061-12.4-57.743t-34.136-18.682q-21.4,0-33.8,18.682T318.114-76.4q0,39.061,12.4,57.743T364.309.023ZM727.749-7.45H689.028V42.481H635.361V-7.45H507.307V-44.473L619.4-195.284h57.743L573.2-52.285h63.857v-44.5h51.969v44.5h38.722Z",
    transform: "translate(611.82 668.401)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M507.307-.45h38.722V49.481H599.7V-.45H727.749V-37.473L615.66-188.284H557.917l103.937,143H598v-44.5H546.028v44.5H507.307ZM372.12,46.557q29.551,0,52.648-14.606t36.174-42.288Q474.02-38.019,474.02-76.4t-13.077-66.065q-13.077-27.683-36.174-42.288T372.12-199.36q-29.551,0-52.648,14.606T283.3-142.466Q270.221-114.784,270.221-76.4T283.3-10.337q13.077,27.683,36.174,42.288T372.12,46.557Zm0-46.534q-21.739,0-34.136-18.682T325.586-76.4q0-39.061,12.4-57.743t34.136-18.682q21.4,0,33.8,18.682t12.4,57.743q0,39.061-12.4,57.743T372.12.023ZM8.68,1.55H47.4V51.481h53.667V1.55H229.122V-35.473L117.033-186.284H59.29l103.937,143H99.37v-44.5H47.4v44.5H8.68Z",
    transform: "translate(1348.249 761.598) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.cdcb01643ae232fdff6f681e3fbce810.svg";
export { ForwardRef as ReactComponent };